import AppRulegroupsIndex from "./ruleGroup.vue";
import AppRulegroupsList from "./list/list.vue";
import AppRulegroupsItem from "./item/item.vue";

const routes = [
  {
    path: "/rulegroup",
    component: AppRulegroupsIndex,
    meta: {
      auth: {
        roles: "ruleGroup.index",
        redirect: { name: "auth.login" },
        forbiddenRedirect: "/403"
      }
    },
    children: [
      {
        path: "",
        name: "ruleGroup.index",
        component: AppRulegroupsList,
        meta: {
          auth: {
            roles: "ruleGroup.index",
            redirect: { name: "auth.login" }
          }
        }
      },
      {
        path: "create",
        name: "ruleGroup.create",
        component: AppRulegroupsItem,
        meta: {
          auth: {
            roles: "ruleGroup.create",
            redirect: { name: "ruleGroup.index" }
          }
        }
      },
      {
        path: ":id",
        name: "ruleGroup.edit",
        component: AppRulegroupsItem,
        meta: {
          auth: {
            roles: "ruleGroup.update",
            redirect: { name: "ruleGroup.index" }
          }
        }
      }
    ]
  }
];

export default routes;
